import React, { forwardRef, useId, useState } from 'react';
import { Icon } from '../ui';
import './SkillControls.css';

export const SkillSelect = forwardRef(function SkillSelect({ className = '', children, ...props }, ref) {
  return <span className="skill-select"><select ref={ref} className={`form-control ${className}`} {...props}>{children}</select><Icon name="chevron" size={16} /></span>;
});

export function ChoiceCard({ title, description, icon = 'skills', checked, className = '', ...props }) {
  return <label className={`skill-choice-card ${checked ? 'is-selected' : ''} ${className}`}>
    <input type="radio" checked={checked} {...props} />
    <span className="skill-choice-icon"><Icon name={icon} /></span>
    <span className="skill-choice-copy"><strong>{title}</strong>{description && <small>{description}</small>}</span>
  </label>;
}

export const packageScope = item => item.scope === 'personal' ? 'Личный' : item.scope === 'project' ? 'Проектный' : 'Базовый';

export function SkillPackageChoices({ packages, selectedIds, onChange, multiple = false, disabled = false, emptyText = 'Опубликуйте подходящий скилл, чтобы выбрать его здесь.' }) {
  const [query, setQuery] = useState('');
  const name = useId();
  const matches = packages.filter(item => item.title.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()));
  return <div className="skill-library-picker">
    <label className="skill-search"><Icon name="search" size={18} /><input type="search" placeholder="Поиск по названию" aria-label="Поиск скиллов" value={query} disabled={disabled} onChange={e => setQuery(e.target.value)} /></label>
    <div className="skill-picker-caption"><span>Доступно: {matches.length}</span><span>Выбрано: {selectedIds.filter(id => packages.some(item => item.id === id)).length}</span></div>
    <div className="skill-picker-list" role="group" aria-label="Опубликованные скиллы">
      {matches.map(item => <ChoiceCard key={item.id} type={multiple ? 'checkbox' : 'radio'} name={name} value={item.id} disabled={disabled} checked={selectedIds.includes(item.id)}
        title={item.title} icon={item.role === 'output_template' ? 'document' : 'skills'}
        description={`${packageScope(item)} · ${item.role === 'output_template' ? 'Шаблон результата' : 'Правила работы'}`}
        onChange={e => onChange(e.target.checked ? multiple ? [...selectedIds.filter(id => id !== item.id), item.id] : [item.id] : selectedIds.filter(id => id !== item.id))} />)}
      {!matches.length && <div className="skill-picker-empty"><Icon name="search" size={24} /><strong>{packages.length ? 'Ничего не найдено' : 'Пока нет подходящих скиллов'}</strong><p>{packages.length ? 'Попробуйте другое название или очистите поиск.' : emptyText}</p></div>}
    </div>
  </div>;
}
